import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeEchancier } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { filtreListPeriodeMonthYear } from '../DashbordBackOffice';
import { statutEchancier } from './EchancierExpert';

function Echancier({filtreClient,chiffreAffaire,selectedClient,selectedBackOfficeValues,width,height}){

    Echancier.propTypes = {
        chiffreAffaire:PropTypes.any,
        filtreClient: PropTypes.any,
        selectedClient:PropTypes.any,
        selectedBackOfficeValues:PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };

    const [chartDataEchancier, setChartDataEchancier] = useState({
        series: [],

        options: {
            labels: [],
            chart: {
                type: 'bar',
                zoom: {
                    enabled: true,
                    //type: 'xy', // Use 'xy' for 2D zoom (x and y-axis) or 'y' for only y-axis zoom
                },
            },
            bar : {
                columnWidth: '50px',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '15%', // Set the desired bar width as a percentage of the available space
                }
            },
            responsive: [{
                options: {
                    legend: {
                        position: 'bottom',
                        offsetY: 40
                    }
                }
            }],
            dataLabels: {
                enabled: false
            },
            //legend: {
            //    position: 'bottom',
            //    offsetY: 40
            //},
            fill: {
                opacity: 1,
            },
        },
    });

    const [selectedClientCheckBoxEchancier, setSelectedClientCheckBoxEchancier] = useState(['all']);
    const [selectedStatutchancier, setSelectedStatutchancier] = useState('all'); // Default selected period
    //const [customDateRange, setCustomDateRange] = useState({});
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 2);

    const [customDateRange, setCustomDateRange] = useState({
        from: currentDate.toISOString().slice(0, 10), // Get formatted date
        to: new Date().toISOString().slice(0, 10), // Get current date in YYYY-MM-DD format
    });
    const { inputSize } = useWindowSize();
    const ITEM_HEIGHT = 48;
    const { i18n } = useTranslation();
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const [selectedBackOfficeEchancier,setSelectedBackOfficeEchancier]=useState('all');
    const [selectedPeriod, setSelectedPeriod] = useState('custom'); // Default selected period

    useEffect(()=>{
        if(Array.isArray(chiffreAffaire)){
            var filteredData = chiffreAffaire;
            if(filtreClient)
                if (!selectedClientCheckBoxEchancier.includes('all')) {
                    filteredData = filteredData.filter(
                        (item) => selectedClientCheckBoxEchancier.includes(item.companyDataId)
                    );
                }

            if (selectedStatutchancier != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.statutPaiementCalculated == selectedStatutchancier
                );
            }
            if(filtreClient)
                if (selectedBackOfficeEchancier != 'all') {
                    filteredData = filteredData.filter(
                        (item) => item.backOfficeId == selectedBackOfficeEchancier
                    );
                }

            if(selectedPeriod)
                filteredData=filtreListPeriodeMonthYear(filteredData,selectedPeriod,customDateRange);

            const {periodes,backofficeArrays}=calculateCAByPeriodeAndEchancier(filteredData,selectedBackOfficeValues);

            setChartDataEchancier((prevState) => {
                return {
                    ...prevState,
                    series:statutEchancier.slice(0,-1).map((office, index) => ({
                        name: office.label,
                        data: backofficeArrays[index],
                    })),
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: periodes
                            //Object.keys(counts)
                            //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
                        },
                    },
                };
            });
        }
    },[selectedClient,chiffreAffaire,selectedPeriod,customDateRange,selectedClientCheckBoxEchancier,selectedStatutchancier,selectedBackOfficeEchancier,selectedBackOfficeEchancier]);

    //Group data by periode and a specific filter item (backOfficeId or statutPaiementCalculated (based on dateEcheancier)) and calculate the totalHtClient for each group.
    const groupData = (data,filtreItem) => {
        let key2;
        let result={};
        data.map((item) => {
            const { periode, totalHtClient } = item;
            key2 = (filtreItem === 'backOffice') ? item.backOfficeId : item.statutPaiementCalculated;

            // Initialize the result object if it doesn't exist yet
            result[periode] = result[periode] || {};
            result[periode][key2] = (result[periode][key2] || 0) + totalHtClient;

        });
        return result;
    };

    const calculateCAByPeriodeAndEchancier = (data) => {
        const groupedData = groupData(data,'statutPaiementEchancier');
        // Construct the final arrays for each periode
        const periodes = Object.keys(groupedData);
        const backofficeArrays = statutEchancier.map(({ value }) =>
            periodes.map((periode) => groupedData[periode][value]?.toFixed(2) || 0)
        );
        return {periodes,backofficeArrays};
    };

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Echéancier')}</h1>
                <div className='filtre1'>
                    {filtreClient &&
                        <div style={{width:'25%'}}>
                            <ThemeProvider theme={FieldComponentFont}>
                                <FormControl style={{width:'100%'}}>
                                    <InputLabel
                                        shrink={true}
                                        id="demo-multiple-checkbox-label"
                                    >{i18n.t('Clients')} </InputLabel>
                                    <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        multiple
                                        value={selectedClientCheckBoxEchancier}
                                        onChange={(event)=>{
                                            const {
                                                target: { value },
                                            } = event;
                                            console.log('typeof value ===',typeof value === 'string' ? value.split(',') : value);
                                            setSelectedClientCheckBoxEchancier(
                                            // On autofill we get a stringified value.
                                                typeof value === 'string' ? value.split(',') : value,
                                            );
                                            if(value.length>0){
                                                if (value[value.length - 1] == 'all') {
                                                    setSelectedClientCheckBoxEchancier(['all']);
                                                } else {
                                                    // If 'all' was selected before, remove it from selectedClientCheckBox
                                                    const updatedSelected = value.includes('all')
                                                        ? value.filter((item) => item !== 'all')
                                                        : value;
                                                    console.log('updatedSelected',updatedSelected);

                                                    setSelectedClientCheckBoxEchancier(updatedSelected);
                                                }
                                            }
                                        }}
                                        size={inputSize}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px' },
                                        }}
                                        style={{ width: '100%', background: 'white' }}
                                        input={<OutlinedInput label="Clients" />}
                                        renderValue={(selected) => {
                                            return selected
                                                .map((id) => {
                                                    const selectedOption = selectedClient.find(
                                                        (element) => element._id === id
                                                    );
                                                    return i18n.t(selectedOption?.label);
                                                })
                                                .join(', ');
                                        }}
                                        MenuProps={MenuProps}
                                    >
                                        {Array.isArray(selectedClient) && selectedClient?.map((element) => (
                                            <MenuItem
                                                key={element._id}
                                                value={element._id}
                                            >
                                                <Checkbox checked={selectedClientCheckBoxEchancier.includes(element._id)} />
                                                <ListItemText primary={i18n.t(element.label)} />
                                            </MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </ThemeProvider>
                        </div>
                    }

                    <div style={{width:'37%'}}>
                        <SelectComponent
                            label='Statut échéancier'
                            val={selectedStatutchancier}
                            name='Statut échéancier'
                            setVal={(e) => {
                                setSelectedStatutchancier(e.target.value);
                            }}
                            listVal={statutEchancier}
                        />
                    </div>
                    {filtreClient &&
                        <div style={{width:'37%'}}>
                            <SelectComponent
                                label={i18n.t('Chargé de recrutement')}
                                val={selectedBackOfficeEchancier}
                                name='Chargé de recrutement'
                                setVal={(e) => {
                                    setSelectedBackOfficeEchancier(e.target.value);
                                }}
                                listVal={selectedBackOfficeValues}
                            />
                            {/*<SelectBackOffice
                                selectedBackOfficevalue={selectedBackOffice}
                                setSelectedBackOfficevalue={setSelectedBackOffice}
                            />*/}
                        </div>
                    }
                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            setCustomDateRange={setCustomDateRange}
                            listeVal={PeriodeEchancier}

                        />
                        {/*<SelectBackOffice
                            selectedBackOfficevalue={selectedBackOfficeCA}
                            setSelectedBackOfficevalue={setSelectedBackOfficeCA}
                        />*/}
                    </div>
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataEchancier.options}
                        series={chartDataEchancier.series}
                        type="bar"
                        width={'100%'}
                        height={'75%'}
                    />
                </div>
            </div>
        </>
    );

}
export default Echancier;